module.exports = {
      id: "spotify-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#spotify",
      toString: function () {
        return this.url;
      }
    }